import React from 'react'
import Home from './components/Home/Home'
import Nav from './components/nav/Nav'
// import Nav1 from './components/nav1/Nav'
import About from './components/about/About'
import Experience from './components/Experience/Experience'
import Services from './components/services/Services'
import Portfolio from './components/Portfolio/Portfolio'
// import Testimonials from './components/testimonials/Testimonials'
import Contact from './components/contacts/Contact'
import Footer from './components/Footer/Footer'
// import Footer1 from './components/Footer1/Footer'
function App() {
  return (
    <>
      <Nav />
      <Home />
      {/* <Nav1 /> */}
      <About />
      <Experience />
      <Services />
      <Portfolio />
      {/* <Testimonials /> */}
      <Contact />
      {/* <Footer1 /> */}
      <Footer />
    </>
  );
}

export default App;
